type FramePreviewProps = {
  frameStyle: string;
  color: string;
  selected: boolean;
};

export function FramePreview({ frameStyle, color, selected }: FramePreviewProps) {
  const width = 52;
  const height = 64;
  const corners = [
    [0, 0, 1, 1],
    [width, 0, -1, 1],
    [0, height, 1, -1],
    [width, height, -1, -1],
  ] as const;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      style={{
        display: "block",
        borderRadius: 8,
        border: `2px solid ${selected ? color : "rgba(255,255,255,0.08)"}`,
        background: selected ? `${color}18` : "rgba(255,255,255,0.02)",
      }}
    >
      <rect x={1.5} y={1.5} width={width - 3} height={height - 3} fill="none" stroke={selected ? color : "rgba(255,255,255,0.18)"} strokeWidth={1.5} rx={8} />
      {frameStyle === "ornate" && corners.map(([cx, cy, dx, dy], index) => (
        <rect key={index} x={cx + dx * 6 - 3} y={cy + dy * 6 - 3} width={6} height={6} fill={color} transform={`rotate(45 ${cx + dx * 6} ${cy + dy * 6})`} />
      ))}
      {frameStyle === "circuit" && corners.map(([cx, cy, dx, dy], index) => (
        <path key={index} d={`M ${cx + dx * 3} ${cy + dy * 15} L ${cx + dx * 3} ${cy + dy * 3} L ${cx + dx * 15} ${cy + dy * 3}`} fill="none" stroke={color} strokeWidth={1.4} />
      ))}
      {frameStyle === "runic" && <rect x={4} y={4} width={width - 8} height={height - 8} fill="none" stroke={color} strokeWidth={0.9} rx={6} strokeDasharray="4 3" opacity={0.7} />}
      {frameStyle === "crystal" && corners.map(([cx, cy, dx, dy], index) => (
        <line key={index} x1={cx + dx * 3} y1={cy + dy * 16} x2={cx + dx * 16} y2={cy + dy * 3} stroke={color} strokeWidth={1.8} />
      ))}
      {frameStyle === "vines" && corners.map(([cx, cy, dx, dy], index) => (
        <path key={index} d={`M ${cx + dx * 3} ${cy + dy * 18} C ${cx + dx * 3} ${cy + dy * 9} ${cx + dx * 6} ${cy + dy * 4} ${cx + dx * 17} ${cy + dy * 3}`} fill="none" stroke={color} strokeWidth={2} />
      ))}
      {frameStyle === "flames" && <polygon points={`0,${height} 10,${height - 8} 18,${height - 3} 26,${height - 9} 34,${height - 4} 42,${height - 10} ${width},${height}`} fill={color} opacity={0.3} />}
      {frameStyle === "galaxy" && [[5, 5], [width - 5, 5], [5, height - 5], [width - 5, height - 5], [width / 2, 4]].map(([x, y], index) => (
        <circle key={index} cx={x} cy={y} r={1.3} fill="#fff" opacity={0.7} />
      ))}
    </svg>
  );
}
